<template>

  <horizontal-bar-chart
      style="width: 100%; height:400px"
      :chartData="getChartData"
      :options="getOptions"/>


</template>

<script>
import HorizontalBarChart from '@/components/oeeAnalytics/charts/horizontalBarChart'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  components: {
    HorizontalBarChart
  },
  mixins: [timeCalc, generalMethods, colours],
  props: ['uniqueProductNumbers'],
  data() {
    return {
      runs: [],
      config: {}
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('oeeAnalytics', ['getProductionRunData']),
    ...mapGetters('company', ['getOeeConfig']),
    getOptions() {
      const self = this
      return {
        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect: false,// duration of animations when hovering an item
        },

        layout: {
          padding: {
            left: 20,
            right: 50,
            top: 0,
            bottom: 0
          }
        },
        title: {
          display: true,
          text: self.$t('oeeAnalytics.performance.topBottom.chartTitle'),
          fontSize: 18,
          fontStyle: 'normal',
          position: 'top',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                // Include a dollar sign in the ticks
                // callback: function (value, index, ticks) {
                //   return value[value.length - 1] //
                // }
              },
              gridLines: {
                display: false
              },
            },
          ],
          xAxes: [{
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
            }
          }],
        },
        legend: {
          display: false,
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              return (parseFloat(tooltipItem.value)).toFixed(2) + ' % | BDR per minute: ' + self.getChartData.datasets[0].data[tooltipItem.index].additional[0].bdr    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: '#464646',
            anchor: 'end',
            align: 'right',
            font: {
              // weight: 'bold',
              size: 15
            },
            offset: 3,

            display: function (ctx) {
              // return false
              return true //ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {

              return parseFloat(value.x).toFixed(2) + '%'

            },

          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (evt, el) {
          try {

            self.$emit('productNumberSelected', el[0]._model.label)
          } catch (e) {
            // self.$emit('reasonSelected', null)
          }
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
      }

    },
    getUniqueKeys() {
      return this.getUniqueDownTimeKeys();
    },
    getBdr() {
      let downTimes = _.clone(this.bdrFromDateRange)
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
      return downTimes
    },
    getChartData() {
      let labels = this.uniqueProductNumbers
      let topDataSet = this.getTopRuns(labels)

      // let filterdDownTime = this.uniqueReasons.length == 1
      let lengthOfData = Math.floor(topDataSet.data.length / 2) >= 5 ? 5 : 4

      let colours = topDataSet.data.map((value, idx) => {
        return value.x < 50 ? this.coloursBasedOnValueTopBottom(value.x, 'bottom') : '#315bb6'
        // return this.coloursBasedOnValueTopBottom(value, idx < _.floor((topDataSet.data.length / 2)) ? 'top' : 'bottom') // value > 0 ? this.getBottomColour : this.getTopColour
      });
      let top = _.take(topDataSet.data, lengthOfData)
      let counter = 0
      let bottom = _.takeRightWhile(topDataSet.data, run => {
            let found = !_.find(top, t => run.y === t.y)
            if (found && counter < 5) {
              counter++
              return true
            }
          }
      )
      let datasets = [
        {
          label: 'Top',
          backgroundColor: [
            ..._.take(colours, top.length),
            ..._.takeRight(colours, bottom.length)],
          data: [
            ...top,
            ...bottom
          ]
        }
      ]

      return {
        labels: [..._.take(topDataSet.labels, top.length), ..._.takeRight(topDataSet.labels, bottom.length)],
        datasets,
      }

    },
  },
  methods: {
    getTopRuns(labels) {
      // crate new array based on length
      let data = new Array(labels.length).fill(0)

      let groupped = _.groupBy(_.filter(this.getProductionRunData, run => {
        let filter = this.getOeeConfig.activitiesThatActLikeUnscheduledDownTime

        if (filter && !filter.includes(run.activity)) {
          return run
        } else {
          if (!filter) {
            return run
          }
        }
      }), run => {
        return run.productNumber
      })

      _.forEach(groupped, (run, key) => {
        let index = _.findIndex(labels, l => {
          return l === key
        })
        if (index >= 0) {
          data[index] = {y: labels[index], x: _.meanBy(run, 'difference') * 100, additional: run}
        }
      })


      const arrayOfObj = labels.map(function (d, i) {
        return {
          label: d,
          data: data[i],
        }
      })

      const sortedArrayOfObj = arrayOfObj.sort(function (a, b) {

        return b.data.x - a.data.x
        // return a.data - b.data
      })
      let newArrayLabel = []
      let newArrayData = []
      sortedArrayOfObj.forEach(function (d) {

        newArrayLabel.push(d.label)
        newArrayData.push(d.data)

      })

      return {
        labels: newArrayLabel,
        data: newArrayData,
      }
    },

  },
  watch: {
    async runIds(newV, oldV) {
      let runs = await this.$FUNCTIONS.OeeAnalytics("getProductionRunsById", {
            ids: newV,
          }
      ).catch(e => {
        this.loading = false
        return
      })
      this.runs = runs.data ? runs.data : null;
    }
  },
  created() {

  }
}
</script>


<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>